const MAX_SUGGESTIONS = 20;

const resolveScopeKey = (scopeKey) => {
  if (scopeKey) return String(scopeKey);
  try {
    const userRaw = localStorage.getItem("user");
    if (userRaw) {
      const user = JSON.parse(userRaw);
      const id = user?.id || user?.documentId || user?.email;
      if (id) return String(id);
    }
  } catch {
    // ignore parse errors
  }
  return "default";
};

const storageKeyFor = (prefix, scopeKey) =>
  `${prefix}:${resolveScopeKey(scopeKey)}`;

const getSuggestions = (prefix, scopeKey) => {
  try {
    const raw = localStorage.getItem(storageKeyFor(prefix, scopeKey));
    if (!raw) return [];
    const parsed = JSON.parse(raw);
    return Array.isArray(parsed)
      ? parsed.filter((item) => typeof item === "string" && item.trim())
      : [];
  } catch {
    return [];
  }
};

const addSuggestion = (prefix, text, scopeKey) => {
  const normalized = String(text || "").trim();
  if (!normalized) return getSuggestions(prefix, scopeKey);

  const existing = getSuggestions(prefix, scopeKey);
  const next = [
    normalized,
    ...existing.filter((item) => item.toLowerCase() !== normalized.toLowerCase()),
  ].slice(0, MAX_SUGGESTIONS);

  try {
    localStorage.setItem(storageKeyFor(prefix, scopeKey), JSON.stringify(next));
  } catch {
    // quota / private mode — ignore
  }
  return next;
};

/**
 * Filters suggestions by query (case-insensitive). Empty query returns all.
 * @param {string[]} suggestions
 * @param {string} query
 * @returns {string[]}
 */
export const filterPaymentCommentSuggestions = (suggestions, query) => {
  const q = String(query || "").trim().toLowerCase();
  if (!q) return suggestions;
  return suggestions.filter((item) => item.toLowerCase().includes(q));
};

export const filterTextSuggestions = filterPaymentCommentSuggestions;

const PAYMENT_COMMENT_PREFIX = "payment_comment_suggestions";
const EMAIL_SUBJECT_PREFIX = "email_subject_suggestions";

export const getPaymentCommentSuggestions = (scopeKey) =>
  getSuggestions(PAYMENT_COMMENT_PREFIX, scopeKey);

export const addPaymentCommentSuggestion = (text, scopeKey) =>
  addSuggestion(PAYMENT_COMMENT_PREFIX, text, scopeKey);

export const getEmailSubjectSuggestions = (scopeKey) =>
  getSuggestions(EMAIL_SUBJECT_PREFIX, scopeKey);

export const addEmailSubjectSuggestion = (text, scopeKey) =>
  addSuggestion(EMAIL_SUBJECT_PREFIX, text, scopeKey);
